<template>
  <div class="wrapper">
    <div class="options">
      <div class="options-wrp" @click="gotoPage('/invoice/add-apply')">
        <div class="options-inner">
          <p class="iconfont">&#xe68d;</p>
          <p class="title">开票申请</p>
        </div>
      </div>
      <div class="options-wrp" @click="gotoPage('/invoice/business/open')">
        <div class="options-inner">
          <p class="iconfont">&#xe6c7;</p>
          <p class="title">电票直开</p>
        </div>
      </div>
    </div>
     <div class="list-wrp">
        <van-tabs style="height: 100%" v-model="active" @click="onTabClick">
          <van-tab title="申请列表">
            <ApplyList v-if="active === 0"/>
          </van-tab>
          <van-tab title="已开发票">
            <InvoiceList v-if="active === 1"/>
          </van-tab>
        </van-tabs>
     </div>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant'
import ApplyList from './ApplyList'
import InvoiceList from './InvoiceList'
import { getQuery } from '@utils/basicUtil'
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    ApplyList,
    InvoiceList
  },
  props: {},
  data () {
    return {
      active: 0
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.initActive()
    sessionStorage.clear()
  },
  activated () {},
  updated () {},
  methods: {
    initActive () {
      let { active } = getQuery()
      if (active === '0' || active === '1') {
        this.active = Number(active)
      }
    },
    gotoPage (link) {
      if (link) {
        this.$router.push(link)
      }
    },
    onTabClick (name) {
      this.$store.commit('invoice/initInvoiceHomeApplySearch')
      this.$store.commit('invoice/initInvoiceHomeInvoiceSearch')
      if (window.location.pathname + window.location.search === `/invoice/invoice-home?active=${name}`) {
        return
      }
      this.$router.replace(`/invoice/invoice-home?active=${name}`)
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
